/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import { Modal, ModalClose, ModalContent, ModalFooter, ModalHeader, ModalTitle, ModalTrigger } from "../ui/Modal";
import Button from "../ui/Button";
import ButtonGroup from "../ui/ButtonGroup";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants/constants";
import { useAuth } from "../../hooks/useAuth";

const ClientLogoutConfirmationModal = ({ trigger }) => {
  const navigate = useNavigate();
  const { logout, isLogoutPending } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate(ROUTES.HOME);
  };

  return (
    <Modal>
      <ModalTrigger>{trigger}</ModalTrigger>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Log out from your account?</ModalTitle>
        </ModalHeader>
        <ModalFooter>
          <ButtonGroup itemsWidth="half" justify="center">
            <ModalClose>
              <Button variant="outline" title="cancel" />
            </ModalClose>
            <ModalClose waitForOnClick>
              <Button variant="primary" title="log_out" onClick={handleLogout} loading={isLogoutPending} />
            </ModalClose>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ClientLogoutConfirmationModal;
